import 'css-chunksrc/client/scenes/costProfileEdition/costHistory/cost/styles.scss';export default {
  "cost": "_cost_1x3fz_1",
  "row": "_row_1x3fz_6",
  "text": "_text_1x3fz_20",
  "iconBox": "_iconBox_1x3fz_28",
  "icon": "_icon_1x3fz_28"
};